<template>
  <div
    id="worksheet-selector"
    class="form-horizontal">
    <PanelTemplate
      :color="'info'"
      :icon="markRaw(IconInfo)">
      {{ $t('messages.multipleWorksheetsWarning') }}
    </PanelTemplate>
    <FormField
      :id="'worksheet-multiselect'"
      :control="worksheetControl"
      :label="$t('messages.selectWorksheet')">
      <Multiselect
        v-model="worksheetControl.value"
        :options="workbook?.worksheets"
        :show-labels="false"
        track-by="id"
        label="name"
        @open="() => emit('dropdownOpen', true)"
        @close="() => emit('dropdownOpen', false)" />
    </FormField>
  </div>
</template>

<script setup lang="ts">
  import { Workbook, Worksheet } from 'exceljs';
  import { markRaw, Ref, ref, watch } from 'vue';
  import { Multiselect } from 'vue-multiselect';

  import FormControl from '@/common/components/generic-form/form-controls/FormControl';
  import FormField from '@/common/components/generic-form/FormField.vue';
  import PanelTemplate from '@/common/components/templates/PanelTemplate.vue';
  import { IconInfo } from '@/common/icons/monochrome';

  interface IProps {
    workbook: Workbook;
    modelValue?: Worksheet;
  }

  const props = defineProps<IProps>();

  interface IEmits {
    (e: 'update:modelValue', value: Worksheet): void;
    (e: 'dropdownOpen', value: boolean): void;
  }

  const emit = defineEmits<IEmits>();

  const worksheetControl = ref(new FormControl<Worksheet>(props.modelValue)) as Ref<FormControl<Worksheet>>;

  watch(
    () => props.modelValue,
    (newValue) => {
      worksheetControl.value.value = newValue;
    },
  );

  watch(
    () => worksheetControl.value.value,
    (newValue) => {
      emit('update:modelValue', newValue);
    },
  );
</script>
